'use strict';

var withStyles = require('../../node_modules/@material-ui/core/styles/withStyles.js');
var Typography = require('../../DesignSystem/DataDisplay/Typography/Typography.js');
require('prop-types');
var React = require('react');
var VerticalSpace = require('../Layouts/VerticalSpace.js');
var PreparerDetails = require('./PreparerDetails.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = {
  logoContainer: {
    width: 200,
    height: 90,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  logo: {
    maxWidth: '100%',
    maxHeight: '100%'
  },
  webkitBoxContainer: {
    display: '-webkit-box',
    width: '100%'
  }
};

var PageHeader = function PageHeader(_ref) {
  var classes = _ref.classes,
      title = _ref.title,
      customerName = _ref.customerName,
      address = _ref.address,
      logoUrl = _ref.logoUrl,
      preparer = _ref.preparer,
      phone = _ref.phone,
      number = _ref.number,
      date = _ref.date,
      settings = _ref.settings,
      isPresenting = _ref.isPresenting;
  var show_logo = settings.show_logo;
  var logo = show_logo && logoUrl && React__default["default"].createElement("div", {
    className: classes.logoContainer
  }, React__default["default"].createElement("img", {
    src: logoUrl,
    className: classes.logo
  }));
  return React__default["default"].createElement("div", {
    className: classes.webkitBoxContainer
  }, React__default["default"].createElement("div", {
    style: {
      WebkitBoxFlex: 4
    }
  }, React__default["default"].createElement(Typography, {
    variant: "h1"
  }, title), customerName && React__default["default"].createElement(React.Fragment, null, React__default["default"].createElement(Typography, {
    variant: "subtitle2"
  }, customerName, " | ", address), React__default["default"].createElement(VerticalSpace, {
    height: 8
  }), React__default["default"].createElement(PreparerDetails, {
    preparer: preparer,
    phone: phone,
    number: number,
    date: date,
    settings: settings,
    isPresenting: isPresenting
  }))), logo);
};

var PageHeader$1 = withStyles(styles)(PageHeader);

module.exports = PageHeader$1;
